// Copied from https://github.com/MSalmanTariq/react-google-one-tap-login/blob/main/src/useGoogleOneTapLogin.ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import useScript from './useScript';
var scriptFlag = '__googleOneTapScript__';
var googleClientScriptURL = 'https://accounts.google.com/gsi/client';
var oauthEndpointURL = 'https://oauth2.googleapis.com/tokeninfo?id_token=';
function callback(_a) {
    var data = _a.data, onError = _a.onError, onSuccess = _a.onSuccess;
    if (data === null || data === void 0 ? void 0 : data.credential) {
        fetch("".concat(oauthEndpointURL).concat(data.credential))
            .then(function (resp) {
            if ((resp === null || resp === void 0 ? void 0 : resp.status) === 200 && (resp === null || resp === void 0 ? void 0 : resp.json)) {
                return resp.json();
            }
            else {
                if (onError) {
                    onError();
                }
                throw new Error('Something went wrong');
            }
        })
            .then(function (resp) {
            if (onSuccess) {
                onSuccess(resp);
            }
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
            throw error;
        });
    }
}
export function useGoogleOneTapLogin(_a) {
    var onError = _a.onError, disabled = _a.disabled, onSuccess = _a.onSuccess, onRender = _a.onRender, googleAccountConfigs = _a.googleAccountConfigs, _b = _a.disableCancelOnUnmount, disableCancelOnUnmount = _b === void 0 ? false : _b;
    var script = useScript(googleClientScriptURL);
    // Use the user's custom callback if they specified one; otherwise use the default one defined above:
    var callbackToUse = googleAccountConfigs.callback
        ? googleAccountConfigs.callback
        : function (data) { return callback({ data: data, onError: onError, onSuccess: onSuccess }); };
    useEffect(function () {
        if (!(window === null || window === void 0 ? void 0 : window[scriptFlag]) && window.google && script === 'ready') {
            // @ts-ignore
            window.google.accounts.id.initialize(__assign(__assign({}, googleAccountConfigs), { callback: callbackToUse }));
            window[scriptFlag] = true;
        }
        if ((window === null || window === void 0 ? void 0 : window[scriptFlag]) && script === 'ready') {
            if (!disabled) {
                // @ts-ignore
                window.google.accounts.id.prompt(function (notification) {
                    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                        // Uncomment the following line just for local dev to redisplay the popup even after the user closed it
                        // document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
                        // @ts-ignore
                        google.accounts.id.prompt();
                    }
                });
                if (onRender)
                    onRender();
            }
            else {
                // @ts-ignore
                window.google.accounts.id.cancel();
            }
            return function () {
                if (!disableCancelOnUnmount) {
                    // @ts-ignore
                    window.google.accounts.id.cancel();
                }
            };
        }
        return;
    }, [script, window === null || window === void 0 ? void 0 : window[scriptFlag], disabled]);
    return null;
}
//# sourceMappingURL=useGoogleOneTapLogin.js.map